import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {CreazionePraticaStoreService} from '../../services/creazione-pratica-store.service';
import {Petitum} from '../../../../../common/models/petitum';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { filterElaborationEntityClean } from '../../utils/wizard-utils';
import { ElaborationEntityConstants } from '../../constants/elaboration-entity-constants';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { TipoPetitum } from 'src/app/common/models/tipologiche/tipo-petitum';
import { isPetitumValid } from '../../utils/petitum-utils';
import { OperationsService } from 'src/app/core/services/operations.service';
import { stepMap } from '../creazione-pratica-stepper/config/step';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';

declare var $: any;

@Component({
  selector: 'step-dati-economici',
  templateUrl: './step-dati-economici.component.html',
  styleUrls: ['./step-dati-economici.component.css']
})
export class StepDatiEconomiciComponent implements OnInit, OnDestroy {

  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>()

  petitumFirstChanges= false;
  petitumLatestValidation = false;
  petitum: Petitum;
  sezione = null;
  isContinueEnabled: boolean = false
  private entities: ElaborationDocumentFilterEntity[];
  private componentDestroyed$: Subject<void> = new Subject<void>();
  tmpPetitum: Petitum;
  tipiPetitum : TipoPetitum[] = [];
  submitPending: boolean = false;
  accordions = stepMap;
  constructor(
    private tipologicheService: CreazionePraticaTipologicheService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private operations: OperationsService
  ) {
  }

  ngOnInit(): void {
    // console.log('[ngOnInit]', '---');
    this.readSezione();
    this.tipologicheService.getTipiPetitum().subscribe(tipoPetitumArray => {
      if(tipoPetitumArray && tipoPetitumArray.length > 0){
        this.tipiPetitum = tipoPetitumArray;


        this.creazionePraticaStoreService.petitum$.subscribe(it => {
          
    
          this.getPetitumSuggested(it);
          
        });


      }
    });
    
  }

  private getPetitumSuggested(it: Petitum) {
    this.creazionePraticaStoreService.entities$.subscribe(entities => {
      if (entities) {
        this.entities = filterElaborationEntityClean(entities, [ElaborationEntityConstants.IMPORTO_ECONOMICO]);

        // console.log('[setPetitum]', '---', it);
        if (it) {
          // console.log('[setPetitum]', '---', "load");
          this.petitum = it;
        } else {
          let petitumSuggerito = new Petitum();

          if (this.entities && this.entities.length > 0) {
            let typeFiltered = this.tipiPetitum.filter(t => t.id === 'QUANTIFICABILE');
            if (typeFiltered && typeFiltered.length === 1) {
              petitumSuggerito.tipoPetitum = typeFiltered[0];
              //let entityFilter = this.entities[this.entities.length - 1];
              let entityFilter = this.entities[0];

              let importo = '';
              if (entityFilter.valore.length > 0) {
                let indexSpace = entityFilter.valore.indexOf(" ");
                importo = entityFilter.valore.substring(indexSpace + 1, entityFilter.valore.length);
                if(importo.includes(".") && importo.includes(",")){
                  importo = importo.replace(/\./g, "");
                }
              }
              petitumSuggerito.importoPetitum = importo;
            }
          }
          this.petitum = petitumSuggerito;
        }

      } else {
        this.petitum = new Petitum();
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.creazionePraticaStoreService.setPetitum(null);
  }

  retrievePetitum(petitum : Petitum){
    this.petitum = petitum;
    this.petitum = this.formatImporto(this.petitum);
    this.creazionePraticaStoreService.setPetitum(this.petitum);
  }

  onValidPetitum(event: boolean) {
    this.isContinueEnabled = event;
    this.creazionePraticaStoreService.updateValidityPetitum(event)
  }

  onReset(): void {
    console.log('[onReset]', '---');
    this.getPetitumSuggested(undefined);
    if(!this.petitum){
      this.petitum = new Petitum();
    }
    this.petitum = this.formatImporto(this.petitum);
    this.creazionePraticaStoreService.setPetitum(this.petitum);
    this.creazionePraticaStoreService.updateValidityPetitum(isPetitumValid(this.petitum))
    this.isContinueEnabled = false;
  }

  onContinue(): void {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ECONOMICA_FASCICOLO);
    let idSezione =
      !!this.accordions[index].properties.fascicolo.idSezioneDatiEconomici
        ? this.accordions[index].properties.fascicolo.idSezioneDatiEconomici
        : "new";
    let idFascicolo = this.accordions[index].properties.fascicolo.id
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    this.petitum = this.formatImporto(this.petitum);
    console.log(this.sezione, 'this.sezione.petitum')
    if(idSezione === PropertiesSettings.NEW_SEZIONE || !this.sezione?.petitum) {
      this.add(tipoPratica, tipoFascicolo, idSezione, idFascicolo, index);
    } else {
      this.update(tipoPratica, tipoFascicolo, idSezione, index);
    }
  }

  private update(tipoPratica: string, tipoFascicolo: string, idSezione: string, index:number) {
    this.operations.updatePetitum(
      this.petitum,
      tipoPratica,
      tipoFascicolo,
      idSezione
    ).subscribe(
      res => {
        this.petitum = res.sezione.petitum;
        this.creazionePraticaStoreService.setPetitum(this.petitum);
        this.accordions[index].complete = true;
        this.readSezione();
      }
    );
  }

  private add(tipoPratica: string, tipoFascicolo: string, idSezione: string, idFascicolo: string, index:number) {
    this.operations.addPetitum(
      this.petitum,
      tipoPratica,
      tipoFascicolo,
      idSezione,
      idFascicolo
    ).subscribe(
      res => {
        this.petitum = res.sezione.petitum;
        this.creazionePraticaStoreService.setPetitum(this.petitum);
        this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
          res => {
            this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
            this.accordions[index].complete = true;
            this.readSezione();
          }
        );
      }
    );
  }

  formatImporto(petitum:Petitum): Petitum{
    if(petitum.importoPetitum){
      let importoString = ''+petitum.importoPetitum;
      if(importoString.includes(".") && importoString.includes(",")){
        importoString = importoString.replace(/\./g, "");
        importoString = importoString.replace(/\,/g, ".");
      } else if(importoString.includes(",")){
        importoString = importoString.replace(/\,/g, ".");
      }
      petitum.importoPetitum = parseFloat(importoString);
    }
    return petitum;
  }

  readSezione() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ECONOMICA_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneDatiEconomici || null;
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/economici`;
    if(!idSezione) return;
    this.operations.readSezione(url, idSezione).subscribe(response => {
      this.submitPending = true;
      this.petitum = {...response.sezione.petitum};
      this.tmpPetitum = {...this.petitum};
      this.sezione = response.sezione;
      this.creazionePraticaStoreService.setPetitum(this.petitum);
      this.accordions[index].properties.sezione = response.sezione;
      this.accordions[index].properties.sezione["esn"] = NomiDescrittoriSezione.SEZIONE_ECONOMICA_FASCICOLO;
      this.accordions[index].complete = true;
    });
  }

  discard() {
    this.submitPending = true;
    this.creazionePraticaStoreService.setPetitum(this.tmpPetitum);
    this.petitum = {...this.tmpPetitum};
  }
}
